import { SocialBlockProps } from 'types';
import { SocialButton } from '../SocialButton';
import { supportedButtonsProps } from './supportedButtons';

import styles from './SocialBlock.module.scss';

export const SocialBlock = ({ actions, redirect }: SocialBlockProps) => {
  return (
    <div className={styles.container}>
      {supportedButtonsProps.map((props) => (
        <SocialButton
          key={props.provider}
          {...props}
          onClick={actions[props.provider]}
          hideCaptionOnMobile={true}
          redirect={redirect}
        />
      ))}
    </div>
  );
};
